// const debug = "initSentry"
const debug = false

export default function initSentry() {

    debug && console.log(debug, "()")
    debug && console.log(debug, "gd.user.settings.debug.errorLogs=", gd.user.settings.debug.errorLogs)

    if (!gd.user.settings.debug.errorLogs) {
        debug && console.log(debug, "Not needed -> Exit")
        return
    }

    if (gdConfig.devMode) {
        debug && console.orange(debug, "not available for gdConfig.devMode=", gdConfig.devMode)
        return
    }

    try {
        // @ts-ignore
        if (typeof(Sentry) !== 'undefined') {
            // @ts-ignore
            Sentry.init({
                dsn: 'https://15d1bc971fe24964af94fb791b97e69f@sentry.io/196546',
                release: '<?= $build ?>',
                ignoreErrors: [
                    'ResizeObserver loop limit exceeded'
                ],
                ignoreUrls: [
                    // Chrome extensions
                    /extensions\//i,
                    /^chrome:\/\//i,
                ]
            });

            // @ts-ignore
            Sentry.setUser({
                email   : gd.user.email,
                id      : gd.user.id
            });
            debug && console.green("Sentry enabled for user ", gd.user.email)
        }
    } catch (e) {
        console.log("Error #kdjd8888d initializing sentry")
        console.error(e)
    }






}

